import Carousel from '../../../../components/molecules/Carousel';
import Slide1 from '../../../../assets/img/png/linking_flow/linking_process_banner_1.webp';
import Slide2 from '../../../../assets/img/png/linking_flow/linking_process_banner_2.webp';
import Slide3 from '../../../../assets/img/png/linking_flow/linking_process_banner_3.webp';
import Slide4 from '../../../../assets/img/png/linking_flow/linking_process_banner_4.webp';
import Slide5 from '../../../../assets/img/png/linking_flow/linking_process_banner_5.webp';

const BANNERS = [Slide1, Slide2, Slide3, Slide4, Slide5];

const LinkingBannersCarousel = () => {
	return (
		<Carousel autoplaySpeed={7000}>
			{BANNERS.map((src, index) => (
				<img
					key={src}
					src={src}
					alt={`banner_${index + 1}`}
					className='relative h-fit-content object-cover rounded-lg'
				/>
			))}
		</Carousel>
	);
};

export default LinkingBannersCarousel;
